



























































import { Vue, Component, Watch } from 'vue-property-decorator'
import { findAllAdmin, findAdminByName, createAdmin, updateAdmin, removeAdmin } from '@/api/admin'


@Component({
  name: 'Admin',
  filters: {
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toLocaleString()
    }
  }
})

export default class extends Vue {
  private paging = {
    page: 1, // 当前所处分页
    limit: 10, // 页面条数
    total: 10 // 总数量
  }
  private userinfoList = []  // 用户列表
  private listLoading = true  // 加载状态
  private searchValue = '' // 搜索框value
  private handleType = 'add'  // add代表新增，edit代表编辑
  private userDialog: Boolean = false
  private userinfo = {   
    id: '',
    user_id: '',    
    password: '',
    name: ''
  }
  private userinfoFormRules = {
    user_id: [
      {required: true, message: '请输入用户名', trigger: 'blur'},
      {pattern: /^[0-9a-zA-Z]+$/, message: '用户名为英文或数字！', trigger: 'blur'}
    ],
    name: [
      {required: true, message: '请输入姓名', trigger: 'blur'},
      {pattern: /^[\u4e00-\u9fa5]+$/, message: '请输入真实姓名', trigger: 'blur'}
    ],
    password: [
      {required: true, message: '请输入密码', trigger: 'blur'},
      {pattern: /^[0-9a-zA-Z]+$/, message: '密码为英文或数字！', trigger: 'blur'}
    ]
  }
  

  created() {
    // 数据初始化
    this.init()
  }

  // 初始化界面
  private init() {
    this.getAllUser()
  }

  // 设置当前所处分页
  private handleCurrentChange(val: number) {
    this.paging.page = val
    this.getAllUser()
  }
  // 设置页面条数
  private handleSizeChange(val: number) {
    this.paging.limit = val
    this.getAllUser()
  }


  // 新增用户
  private handleAdd() {
    this.resetForm()
    this.handleType = 'add'
    this.userDialog = true;
  }
  // 编辑用户
  private handleEdit(index: number, row: any) {
    this.handleType = 'edti'
    this.userDialog = true;
    this.userinfo = row 
  }
  // 删除用户
  private handleDele(index: number, row: any) {
    this.$confirm('是否删除该用户?', '提示', { type: 'warning' })
      .then(() => {
        this.userinfo = row 
        this.deleUser()
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });          
      });
  }
  // 确认表单
  private confirmForm(index: number, row: any) {
    (this.$refs.userinfoForm as any).validate((valid:boolean) => {
      if (valid) {
        this.handleType==='add' ? this.addUser() : this.editUser();
      } else {
        return false;
      }
    })
  }
  // 重置表单
  private resetForm() {
    this.$nextTick(() => {
      this.userinfo = {   
        id: '',
        user_id: '',    
        password: '',
        name: ''
      }
    })
  }
  

  private async getAllUser() {
    this.listLoading = true
    const { data } = await findAllAdmin(this.paging)
    this.userinfoList = data.rows
    this.paging.total = data.count // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }
  private async getUserByUsername() {
    this.listLoading = true
    const { data } = await findAdminByName({name: this.searchValue})
    this.userinfoList = data
    this.paging.total = data.length // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }
  
  private async addUser() {
    const { data, code } = await createAdmin(this.userinfo)
    if(code===200) {
      this.getAllUser()
      this.userDialog = false
    }
  }
  private async editUser() {
    const { data, code } = await updateAdmin(this.userinfo)
    if(code===200) {
      this.getAllUser()
      this.userDialog = false
    }
  }
  private async deleUser() {
    const { data, code } = await removeAdmin(this.userinfo)
    if(code===200) this.getAllUser()
  }
}
